export default __webpack_public_path__ + "static/O0073-71943f1d5638af329df4cf9fdad08285.png";